var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConvertibleHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29435",
    "data-name": "Group 29435",
    transform: "translate(-556 -502.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(556 502.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_10_",
    "data-name": "svgexport-17 (10)",
    transform: "translate(569 512.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50470",
    "data-name": "Path 50470",
    d: "M19.117,5.64a.294.294,0,0,1-.259-.154A6.256,6.256,0,0,0,16.45,2.824a.272.272,0,0,0-.127-.031H15.63a4.776,4.776,0,0,1,1.873,2.5.294.294,0,0,1-.57.11c-.263-1.386-2.368-2.636-2.39-2.649a.294.294,0,0,1,.145-.544h1.636A.813.813,0,0,1,16.7,2.3a6.758,6.758,0,0,1,2.667,2.908.294.294,0,0,1-.254.439ZM1.03,7.039h-.4a.294.294,0,0,1,0-.583h.4a.632.632,0,0,0,.632-.632V5.407a.294.294,0,0,1,.588,0v.417A1.219,1.219,0,0,1,1.03,7.039Zm25.705,1H25.6a1.732,1.732,0,0,1-1.728-1.732V6.056a.294.294,0,0,1,.583,0v.254A1.146,1.146,0,0,0,25.6,7.455h1.14a.294.294,0,1,1,0,.588ZM6.3,8.885a1.649,1.649,0,1,0,1.649,1.649A1.649,1.649,0,0,0,6.3,8.885Zm0,3.881A2.237,2.237,0,1,1,8.534,10.53,2.237,2.237,0,0,1,6.3,12.767ZM21.779,8.885a1.649,1.649,0,1,0,1.653,1.649,1.649,1.649,0,0,0-1.653-1.649Zm0,3.881a2.237,2.237,0,1,1,2.241-2.232,2.237,2.237,0,0,1-2.241,2.232Z",
    transform: "translate(-0.328 -2.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50471",
    "data-name": "Path 50471",
    d: "M23.753,9.281a.294.294,0,1,1,0-.588c1.991-.009,2.4-.022,2.465-.031.281-.044.333-.18.342-.224V7.453c.009-1.456-.219-1.68-.329-1.785L26.2,5.632c-.886-.912-5.1-1.474-7.057-1.561H5.644a.715.715,0,0,1-.513-.215l-.425-.425a.57.57,0,0,0-.658-.118l-.5.228c-.482.219-.987.447-1.316.57a.3.3,0,0,1-.105.018H1.1a.149.149,0,0,0-.154.154V7.417c0,.636.316.741.368.754l.044.009,1.491.482H4.385a.294.294,0,1,1,0,.588l-1.583,0a.289.289,0,0,1-.088-.013L1.192,8.742C.885,8.681.355,8.334.359,7.413V4.282A.739.739,0,0,1,1.1,3.545h.974c.316-.118.781-.333,1.228-.535l.5-.232a1.162,1.162,0,0,1,1.307.241l.425.425a.132.132,0,0,0,.1.044H19.161c1.193.053,6.281.526,7.456,1.737l.022.026c.263.254.513.632.509,2.2V8.479a.9.9,0,0,1-.842.763C26.249,9.251,26.13,9.268,23.753,9.281Zm-3.881,0c-2.974,0-6.877,0-11.6-.018a.294.294,0,0,1,0-.583c4.728.013,8.636.022,11.6.022a.294.294,0,1,1,0,.583Z",
    transform: "translate(-0.359 -0.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50472",
    "data-name": "Path 50472",
    d: "M5.228,8.675H.654a.294.294,0,1,1,0-.588H5.228a.294.294,0,0,1,0,.583Zm15.486,0H7.417a.294.294,0,1,1,0-.588h13.3a.294.294,0,0,1,0,.583Zm6.14,0H22.9a.294.294,0,1,1,0-.588h3.947a.294.294,0,0,1,0,.583ZM13.6,6.5h-.61a.294.294,0,0,1,0-.583H13.6a.294.294,0,0,1,0,.583ZM6.325,9.548a.436.436,0,1,0,.439.434.439.439,0,0,0-.439-.434Zm0,1.456A1.022,1.022,0,1,1,7.347,9.982,1.022,1.022,0,0,1,6.325,11ZM21.807,9.548a.436.436,0,1,0,.439.434.439.439,0,0,0-.439-.434Zm0,1.456a1.022,1.022,0,1,1,1.022-1.022A1.022,1.022,0,0,1,21.807,11ZM11.833,5.088a.294.294,0,0,1-.285-.232l-.294-1.377c-.026-.123-.132-.518-.465-.518a.544.544,0,0,0-.4.189.225.225,0,0,0-.061.206l.294,1.382a.294.294,0,1,1-.57.118l-.3-1.377a.825.825,0,0,1,.18-.7,1.127,1.127,0,0,1,.86-.4,1.1,1.1,0,0,1,1.039.982l.289,1.382a.294.294,0,0,1-.285.351Z",
    transform: "translate(-0.356 -1.658)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50473",
    "data-name": "Path 50473",
    d: "M11.366,3.621H5.19a.715.715,0,0,1-.513-.215l-.425-.425a.57.57,0,0,0-.658-.118l-.5.228c-.465.211-.943.43-1.272.553v.162A1.219,1.219,0,0,1,.607,5.02H.493v1.6h4.2a2.219,2.219,0,0,1,2.355,0H20.181a2.219,2.219,0,0,1,2.355,0H26.1q-.006-.3-.039-.6h-.886a1.732,1.732,0,0,1-1.728-1.732V4.27a29.767,29.767,0,0,0-4.772-.645H11.366ZM12.55,5.029a.294.294,0,0,1,0-.583h.6a.294.294,0,0,1,0,.583h-.61Z",
    transform: "translate(0.095 -0.192)",
    fill: "#ffe600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50474",
    "data-name": "Path 50474",
    d: "M.607,3.764a.632.632,0,0,0,.632-.632V3.005H.647a.149.149,0,0,0-.154.154v.605H.611Z",
    transform: "translate(0.095 0.482)",
    fill: "#ff9801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50475",
    "data-name": "Path 50475",
    d: "M4.054,3.813H.5c.061.421.307.5.351.513l.044.009,1.491.482H3.646a2.219,2.219,0,0,1,.408-1.009Z",
    transform: "translate(0.108 3.204)",
    fill: "#fec902"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50476",
    "data-name": "Path 50476",
    d: "M4.638,5.326A1.649,1.649,0,0,0,1.344,5.3v.013a1.649,1.649,0,0,0,3.294,0ZM2.993,4.3A1.022,1.022,0,1,1,1.967,5.318,1.022,1.022,0,0,1,2.993,4.3Z",
    transform: "translate(2.976 3.007)",
    fill: "#a39e9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50477",
    "data-name": "Path 50477",
    d: "M2.134,3.813a2.219,2.219,0,0,1,.408,1.022L13.6,4.857a2.219,2.219,0,0,1,.412-1.048H2.13Z",
    transform: "translate(5.637 3.204)",
    fill: "#fec902"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50478",
    "data-name": "Path 50478",
    d: "M2.494,4.48a.439.439,0,1,0-.436.395A.439.439,0,0,0,2.494,4.48Zm15.048-.434a.436.436,0,1,0,.439.434.439.439,0,0,0-.439-.434Z",
    transform: "translate(3.909 3.844)",
    fill: "#d1c9c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50479",
    "data-name": "Path 50479",
    d: "M6.523,4.359A1.022,1.022,0,1,1,5.5,5.381,1.022,1.022,0,0,1,6.523,4.359Zm0,2.671A1.649,1.649,0,0,0,8.172,5.407q0-.013,0-.026A1.649,1.649,0,1,0,6.523,7.03Z",
    transform: "translate(14.928 2.943)",
    fill: "#a39e9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50480",
    "data-name": "Path 50480",
    d: "M5.662,3.813a2.18,2.18,0,0,1,.412,1.035C7.829,4.84,8.2,4.827,8.267,4.818c.276-.044.329-.18.338-.224V3.809H5.666Z",
    transform: "translate(17.596 3.204)",
    fill: "#fec902"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50481",
    "data-name": "Path 50481",
    d: "M5.862,3.173A1.145,1.145,0,0,0,7,4.195h.746A.629.629,0,0,0,7.6,3.976l-.035-.035A4.12,4.12,0,0,0,5.862,3.173Z",
    transform: "translate(18.273 1.051)",
    fill: "#ff9801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50482",
    "data-name": "Path 50482",
    d: "M3.786,4.051,3.566,3.025C3.54,2.9,3.435,2.507,3.1,2.507a.544.544,0,0,0-.4.189.225.225,0,0,0-.061.206l.241,1.149h.908Z",
    transform: "translate(7.333 -1.204)",
    fill: "#7d9dd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50483",
    "data-name": "Path 50483",
    d: "M3.848,2.343A5.115,5.115,0,0,1,5.664,4.606H6.826A5.822,5.822,0,0,0,4.668,2.369a.272.272,0,0,0-.127-.026Z",
    transform: "translate(11.454 -1.76)",
    fill: "#4cf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertibleHighlighted);
export default __webpack_public_path__ + "static/media/convertibleHighlighted.8d610332c18604d4c897b509885d9193.svg";
export { ForwardRef as ReactComponent };